import styled from '../../Styles/themed-styled-components';

export const ErrorPageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
`;
